const appBarHeight = 50;
const tabsHeight = 49;
const defaultBoxShadow = 'rgba(0, 0, 0, 0.3) -4px 5px 13px';
const videoBoxShadow = 'rgba(0, 0, 0, 0.4) 0px 3px 12px';
const slightBoxShadow= 'rgba(0, 0, 0, 0.3) -1px 1px 4px';

export { appBarHeight, defaultBoxShadow, slightBoxShadow, tabsHeight, videoBoxShadow };
